import { type CrudList, PastaCrudApi, useClassFactory } from "@pasta/box-v2";
import { type CreateLetterFileSavedFluxDto, type LetterFileSavedFluxDto } from "../dto/letter-file-saved-flux.dto";
import { subject } from "@casl/ability";

export class LetterFileSavedFluxApi extends PastaCrudApi<{
  Entity: LetterFileSavedFluxDto;
  CreateDto: CreateLetterFileSavedFluxDto;
}> {
  protected readonly baseEndpoint = `saved-flux/`;

  map(entity: LetterFileSavedFluxDto) {
    return subject("LetterFileSavedFlux", entity);
  }

  /** the saved flux of the current user (filtered by the back end) */
  async getMine() {
    const result = await this.network.get<CrudList<LetterFileSavedFluxDto>>(`${this.baseEndpoint}mine`);
    return result.data;
  }
}

export const [letterFileSavedFluxApiToken, useLetterFileSavedFluxApi] = useClassFactory(LetterFileSavedFluxApi);
